import Enum from './enum'

/**
 * 実施題材マスタ コメント機能
 */
class OptionCommentDisclosed extends Enum {
    static PUBLISHED = 1; // 公開
    static ANONYM = 2; // 匿名公開
    static HIDE = 9; // 非公開

    static values() {
        return {
            [this.PUBLISHED]: '公開',
            [this.ANONYM]: '匿名公開',
            [this.HIDE]: '非公開',
        }
    }

    //作品写真の児童間共有が「なし」の場合に、disabledにする値
    static keysCanBeDisabled() {
        return [
            this.PUBLISHED,
            this.ANONYM,
        ]
    }
}

export default OptionCommentDisclosed;
